import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6zm3.5 6l8.5 6V6l-8.5 6zm6.5 2.14L12.97 12 16 9.86v4.28z"
}), 'SkipPreviousOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipPreviousOutlined.js
// module id = 6269
// module chunks = 2